var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-secondary-body"},[_c('cash-hero-navbar',{attrs:{"bright":true}}),_c('div',{staticClass:"content-margin-top"},[_c('router-view')],1),_c('v3-cash-hero-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }